import { Link } from 'react-router-dom'

import type { RechazoDeLaSemana } from '@/lib/supabase/tipos-bd'
import { fecha } from '@/shared/utilidades/formato'

import { abreviado } from './cifras'
import estilos from './CifrasDelPeriodo.module.css'

/**
 * POR QUÉ SE RECHAZARON.
 *
 * Johan: «¿el porqué del rechazo se sabe?». Se sabe, y siempre: si rechaza
 * MEGA el motivo es obligatorio, y si rechaza el cliente por el enlace queda
 * lo que él escribió. Cada uno con quién lo rechazó, porque no es lo mismo:
 * que el cliente diga que no es plata que se pierde; que MEGA la frene es
 * una cotización que había que corregir.
 */
export function Rechazos({ rechazos }: { rechazos: RechazoDeLaSemana[] }) {
  if (rechazos.length === 0) {
    return <p className={estilos.vacio}>No se rechazó ninguna cotización en este periodo.</p>
  }

  return (
    <ul className={estilos.rechazos}>
      {rechazos.map((r) => (
        <li key={`${r.cotizacion}-${r.cuando}`} className={estilos.rechazo}>
          <p className={estilos.rechazoTope}>
            <Link to={`/ordenes/${r.orden_servicio_id}`} className={estilos.rechazoDoc}>
              {r.cotizacion}
            </Link>
            <span className={r.por_el_cliente ? estilos.quienCliente : estilos.quienMega}>
              {r.por_el_cliente ? 'La rechazó el cliente' : `La rechazó ${r.quien}`}
            </span>
            <span className={estilos.rechazoValor}>{abreviado(Number(r.valor))}</span>
          </p>
          <p className={estilos.rechazoCliente}>
            {r.cliente ?? 'Sin cliente'} · {fecha(r.cuando)}
          </p>
          <p className={estilos.motivo}>
            {r.motivo ? `«${r.motivo}»` : 'El cliente no escribió el motivo.'}
          </p>
        </li>
      ))}
    </ul>
  )
}
